<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row justify="end">
    <v-dialog persistent v-model="campaingDetails" max-width="900px">
      <v-card>
        <v-card-title class="justify-center">
          <span class="headline">{{$t(translationName+'.add')}}</span>
          <v-spacer/>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-on:submit.prevent>
              <v-stepper v-model="e1">
                <!--                =================== Kategorije ===================-->
                <v-stepper-step v-if="e1 == 1" step="1" editable>Kategorije</v-stepper-step>
                <v-stepper-content v-if="e1 == 1" step="1">
                  <v-row>
                    <v-btn
                      class="primary ml-3"
                      @click="openChooseCategoryDialog"
                    >
                      Izaberite kategorije
                    </v-btn>
                  </v-row>
                  <v-container>
                    <v-data-table
                      :headers="headersCategories"
                      :items="form.categories"
                      :items-per-page="100"
                      :footer-props="{itemsPerPageOptions: [10,20,30,50, 100]}"
                      :dense="true"
                      :loading-text="$t('loading_data')"
                      sort-by="id"
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-layout align-center justify-center>
                          <v-btn icon @click="deleteCategory(item)">
                            <v-icon color="red">mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </v-layout>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-stepper-content>


                <!--                =================== Partneri ===================-->
                <v-stepper-content v-if="e1 == 2" step="2">
                  <v-row>
                    <v-btn class="ml-4"
                           color="primary"
                           @click="openChoosePartnerDialog"
                    >
                      Dodaj partnera
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-row>
                  <v-container>
                    <v-data-table
                      :headers="headersPartners"
                      :items="form.partners"
                      :items-per-page="100"
                      :footer-props="{itemsPerPageOptions: [10,20,30,50, 100]}"
                      :dense="true"
                      :loading-text="$t('loading_data')"
                      sort-by="id"
                    >
                      <template v-slot:item.pivot.cash="{ item }">
                        <v-text-field
                          label="Cash"
                          v-model="item.pivot == undefined ? item.pivot = {cash: 0} : item.pivot.cash"
                          autocomplete="off"
                          :rules="rules.valid_cash"
                        />
                      </template>

                      <template v-slot:item.actions="{ item }">
                        <v-layout align-center justify-center>
                          <v-btn icon @click="deletePartner(item)">
                            <v-icon color="red">mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </v-layout>
                      </template>

                    </v-data-table>
                  </v-container>
                </v-stepper-content>
                <!--                =================== Proizvodi ===================-->
                <v-stepper-step v-if="e1 == 3" step="3">Proizvodi</v-stepper-step>
                <v-stepper-content v-if="e1 == 3" step="3">
                  <v-row>
                    <v-btn class="ml-3 primary"
                           @click="openChooseProductDialog"
                    >
                      Izaberite proizvode
                    </v-btn>
                  </v-row>
                  <v-data-table
                    :headers="headersProducts"
                    :items="form.products"
                    :items-per-page="100"
                    :footer-props="{itemsPerPageOptions: [10,20,30,50, 100]}"
                    :dense="true"
                    :loading-text="$t('loading_data')"
                    sort-by="id"
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-layout align-center justify-center>
                        <v-btn icon @click="deleteProduct(item)">
                          <v-icon color="red">mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </v-layout>
                    </template>
                  </v-data-table>
                </v-stepper-content>

              </v-stepper>
            </v-form>
          </v-container>


          <small>{{$t('required_fields')}}</small>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text :disabled="loading" @click="closeDialog">{{$t('close')}}</v-btn>
          <v-btn color="blue darken-1" text :loading="loading" @click="edit">{{$t('add')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <choose-categories
      :chooseCategoryDialogData="chooseCategoryDialogData"
      :chooseCategoryDialog="chooseCategoryDialog"
      @close="chooseCategoryDialog=false"
      @add="addCategoryEmit"/>

    <choose-products
      :chooseProductDialogData="chooseProductDialogData"
      :chooseProductDialog="chooseProductDialog"
      @close="chooseProductDialog=false"
      @add="addProductEmit"/>

    <choose-partners
      :choosePartnerDialogData="choosePartnerDialogData"
      :choosePartnerDialog="choosePartnerDialog"
      @close="choosePartnerDialog=false"
      @add="addPartnerEmit"/>
    <!---------------------------------- Choose file  ----------------------------------------->
    <choose-file
      :chooseFileDialog="chooseFileDialog"
      :api="'saveCampaignPartners'"
      @close="chooseFileDialog=false"
      @successEmit="successEmit"/>

  </v-row>
</template>


<script>
  import axios from 'axios';
  import {
    add,
    edit,
    editEmit,
    findById,
    readCategoriesActive,
    readPatners,
    readProducts
  } from "../../statics/DataTableFunctions";
  import campaignDetailsProducts from "../partnersDetails/campaignDetailsProducts";
  import campaignDetailsCategories from "../partnersDetails/campaignDetailsCategories";
  import campaingDetailsPartners from "../partnersDetails/campaingDetailsPartners";
  import ChooseCategories from "./ChooseCategories";
  import ChooseProducts from "./ChooseProducts";
  import ChoosePartners from "./ChoosePartners";
  import Excel from "../excel/Excel";

  export default {
    name: "DetailsPartner",
    props: {
      dataForModal: {},
      campaingDetails: false,
      k1: '',
    },
    components: {
      'partners': campaingDetailsPartners,
      'categories': campaignDetailsCategories,
      'products': campaignDetailsProducts,
      'choose-categories': ChooseCategories,
      'choose-products': ChooseProducts,
      'choose-partners': ChoosePartners,
      'choose-file': Excel
    },
    computed: {
      headersCategories() {
        return [
          {text: 'Name', name: 'name', align: 'left', sortable: true, value: 'name'},
          {text: '', name: 'actions', align: 'left', sortable: false, value: 'actions', width: '50px'},
        ]
      },
      headersProducts() {
        return [
          {text: 'Name', name: 'name', align: 'left', sortable: true, value: 'name'},
          {text: '', name: 'actions', align: 'left', sortable: false, value: 'actions', width: '50px'},
        ]
      },
      headersPartners() {
        return [
          {text: 'Name', name: 'name', align: 'left', sortable: true, value: 'name'},
          {text: 'City', name: 'city', align: 'left', sortable: true, value: 'city.name'},
          {text: 'Pin', name: 'pin', align: 'left', sortable: true, value: 'pin'},
          {text: 'Cash', name: 'cash', align: 'left', sortable: true, value: 'pivot.cash'},
          {text: '', name: 'actions', align: 'left', sortable: false, value: 'actions', width: '50px'},
        ]
      },
    },
    data() {
      return {
        translation: 'campaigns',
        api: 'campaignDetails',
        chooseCategoryDialogData: null,
        chooseProductDialogData: null,
        choosePartnerDialogData: null,
        chooseCategoryDialog: false,
        chooseProductDialog: false,
        choosePartnerDialog: false,
        chooseFileDialog: false,
        translationName: '',
        e1: 2,
        snackbar: {
          color: 'success',
          show: false,
          text: '',
          timeout: 3000,
        },
        loading: false,
        rules: {
          required: [
            v => v.length > 0 || this.$t('validation.field'),
          ],
          valid_cash: [
            v => !!v || this.$t('validation.field'),
            v => +v >= 0 || this.$t(this.translation + '.valid_price'),
          ]
        },
        form: {
          products: [],
          categories: [],
          partners: [],
        },
        lala: null,
      }
    },
    methods: {
      edit() {
        if (!this.$refs.form.validate()) {
          this.snackbar.color = 'error';
          this.snackbar.text = this.$t('snackbar_required');
          this.snackbar.show = true;
          return;
        }

        let data = {
          partners: [],
          categories: [],
          products: []
        };

        for (let i = 0; i < this.form.partners.length; i++) {
          data.partners.push({
            partner_id: '',
            cash: ''
          });
        }
        for (let i = 0; i < this.form.categories.length; i++) {
          data.categories.push({
            category_id: '',
          });
        }
        for (let i = 0; i < this.form.products.length; i++) {
          data.products.push({
            product_id: '',
          });
        }

        for (let i = 0; i < this.form.partners.length; i++) {
          data.partners[i].partner_id = this.form.partners[i].id;
          data.partners[i].cash = this.form.partners[i].pivot.cash;
        }
        for (let i = 0; i < this.form.categories.length; i++) {
          data.categories[i].category_id = this.form.categories[i].id;
        }
        for (let i = 0; i < this.form.products.length; i++) {
          data.products[i].product_id = this.form.products[i].id;
        }

        this.loading = true;
        axios.put('api/campaignDetails/' + this.dataForModal.id, data).then((response) => {
          this.$emit('editEmit', response.data)
          this.snackbar.color = 'success';
          this.snackbar.text = this.$t('edit_success');
          this.snackbar.show = true;
          this.loading = false;
          this.$emit('editEmit', response.data)
          this.closeDialog();
        }).catch(error => {
          if (error.response.status == 401) {
            this.loading = false
            this.$swal.fire({
              type: 'info',
              title: "Info",
              text: this.$t('validation.session'),
            })
            this.$router.push('/login')
          } else {
            this.loading = false;
            this.$swal.fire({
              type: 'error',
              title: this.$t('validation.error'),
              text: this.$t('validation.error'),
            })
          }
        })
      },
      editEmit,
      deleteCategory(item) {
        this.form.categories.splice(this.findById(item.id, this.form.categories), 1);
        let tempPartners = [];
        let bool;
        for (let i = 0; i < this.form.partners.length; i++) {
          bool = false;
          for (let j = 0; j < this.form.partners[i].categories.length && !bool; j++) {
            for (let k = 0; k < this.form.categories.length; k++) {
              if (this.form.partners[i].categories[j].name === this.form.categories[k].name) {
                bool = true;
              }
            }
          }
          if (!bool) {
            tempPartners.push(this.form.partners[i]);
          }
        }
        for (let j = 0; j < tempPartners.length; j++) {
          this.form.partners.splice(this.findById(this.form.partners, tempPartners[j]));
        }
      },
      deleteProduct(item) {
        this.form.products.splice(this.findById(item.id, this.form.products), 1);
      },
      deletePartner(item) {
        this.form.partners.splice(this.findById(item.id, this.form.partners), 1);
      },
      addCategoryEmit(data) {
        this.form.categories = data;
        this.chooseCategoryDialog = false;
      },
      addProductEmit(data) {
        this.form.products = data;
        this.chooseProductDialog = false;
      },
      addPartnerEmit(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].pivot === undefined) {
            data[i].pivot = {cash: 0}
          }
        }
        this.form.partners = data;
        this.choosePartnerDialog = false;
      },
      successEmit(data) {
        this.form.partners = data.partners;
        this.chooseFileDialog = false;
      },
      openChooseCategoryDialog() {
        this.chooseCategoryDialog = true;
        this.chooseCategoryDialogData = this.form.categories;
      },
      openChooseProductDialog() {
        this.chooseProductDialog = true;
        this.chooseProductDialogData = this.form.products;
      },
      openChoosePartnerDialog() {
        this.choosePartnerDialog = true;
        this.choosePartnerDialogData = {partners: this.form.partners, categories: this.form.categories};
      },
      closeDialog() {
        document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0;
        this.$emit('close', false)
        this.e1 = '';
      },
      findById,
    },
    watch: {
      campaingDetails: function (val) {
        if (val) {
          this.form = {
            partners: this.dataForModal.partners,
            categories: this.dataForModal.categories,
            products: this.dataForModal.products,
          };
          this.e1 = this.k1;
          if(this.k1 == 1){
            this.translationName = 'categories';
          }else if(this.k1 == 2){
            this.translationName = 'partners';
          }else{
            this.translationName = 'products';
          }
        }
      },
    },
    created() {
    }
  }
</script>

<style scoped>
</style>
